import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ContentHomeSlider pattern-slider" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentHomeSliderItem = _resolveComponent("ContentHomeSliderItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      duration: 500,
      name: "fade"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_ContentHomeSliderItem, {
          id: _ctx.activeElementNumber,
          key: _ctx.activeElementNumber,
          "image-path": _ctx.activeImagePath,
          class: "pattern-slider__image",
          tablet: _ctx.isBigTablet,
          safari: _ctx.isSafari
        }, null, 8, ["id", "image-path", "tablet", "safari"]))
      ]),
      _: 1
    })
  ]))
}